export interface SamplePoint {
  x: number;
  y: number;
}

export function SampleDomain(
  fn: (x: number) => number,
  domain: readonly [number, number],
  count = 80,
  log = false,
): SamplePoint[] {
  const [a, b] = domain;
  const la = log ? Math.log(a) : a;
  const lb = log ? Math.log(b) : b;
  return Array.from({ length: count }, (_, i) => {
    const u = la + ((lb - la) * i) / Math.max(1, count - 1);
    const x = log ? Math.exp(u) : u;
    return { x, y: fn(x) };
  });
}
